import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

export default class BlockTableLot {
	static init() {
		this.buildCollapses();
	}

	static buildCollapses() {
		let collapses = document.querySelectorAll('.collapse-head');
		if (collapses) {
			collapses.forEach((collapse) => {
				let parent = collapse.closest('.collapse');
				let content = parent.querySelector('.collapse-body');
				collapse.addEventListener('click', () => {
					parent.classList.toggle('open');
					if (parent.classList.contains('open')) {
						content.style.maxHeight = content.scrollHeight + "px";
						setTimeout(() => {
							content.style.overflow = "auto";
						}, 500);
					} else {
						content.style.maxHeight = null;
						content.style.overflow = "hidden";
					}
				});

				// Tri du tableau des lots
				const siblingsSorters = content.querySelectorAll("[data-sort]");
				siblingsSorters.forEach(sort => {
					const container = content.querySelector("tbody");
					sort.addEventListener("click", () => {
						siblingsSorters.forEach(s => s.classList.remove("active"));
						sort.classList.add("active");

						let order = 1;
						if (sort.classList.contains("reverse")) {
							order = -1;
						}
						sort.classList.toggle("reverse");

						switch (sort.dataset.sort) {
							case "reference":
							case "orientation":
								Array.from(container.children)
									.sort((a, b) => {
										if (order === 1) {
											return b.dataset[sort.dataset.sort].localeCompare(a.dataset[sort.dataset.sort]);
										} else {
											return a.dataset[sort.dataset.sort].localeCompare(b.dataset[sort.dataset.sort]);
										}
									})
									.forEach(element => container.appendChild(element));
								break;
							case "outdoorarea":
							case "area":
							case "floor":
							case "price":
							case "reducedPrice":
							default:
								let children = Array.from(container.children);
								children.sort((a, b) => {
									let reverseOrder = -1;
									if (order === -1){
										reverseOrder = 1;
									}
									let tmp = parseFloat(a.dataset[sort.dataset.sort]) < parseFloat(b.dataset[sort.dataset.sort]) ? order : reverseOrder;
									return tmp;
								});
								children.forEach(element => {
									container.appendChild(element);
								});
								break;
						}
					});
				});
			});
		}
	}

}
